import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { BannersState, BANNERS_SLICE_NAME } from './models';

export const bannersSelector = (state: RootState): BannersState => state[BANNERS_SLICE_NAME];

export const selectBannersIsLoading = createSelector(bannersSelector, (state: BannersState) => state.isLoading);

export const selectQuery = createSelector(bannersSelector, (state: BannersState) => state.query);

export const selectBanner = createSelector(bannersSelector, (state: BannersState) => state.banner);
